export default __webpack_public_path__ + "static/media/mnemonic.556fe667.png";